import { entriesOf } from "utils/collect";
export const MODEL_TYPES = ["CONTENT_GENERATION", "EMBEDDING", "RERANKING"];
export const MODEL_STATUS = ["ERROR", "PROVISIONING", "ENABLED", "DISABLED"];
export const CONNECTION_TYPES = [
    "OPEN_AI",
    "AZURE_OPEN_AI",
    "ANTHROPIC",
    "VERTEX_AI_GEMINI",
    "VERTEX_AI",
    "BEDROCK",
    "LLAMA_CPP_AVX2",
    "NVCF_HF",
    "NVCF_NIM",
    "NIM_LLM",
    "NVCF_FT",
    "DGX"
];
export function createQueryParams(query) {
    return entriesOf(query).reduce((p, [k, v]) => {
        p.append(k.toString(), (v ?? "").toString());
        return p;
    }, new URLSearchParams(""));
}
export const FINE_TUNING_EXECUTION_STATUSES = [
    "PENDING",
    "RUNNING",
    "SUCCEEDED",
    "FAILED",
    "CANCELLING",
    "CANCELLED"
];
export var FineTuningExecutionType;
(function (FineTuningExecutionType) {
    FineTuningExecutionType["TRAINING"] = "TRAINING";
    FineTuningExecutionType["EVALUATION"] = "EVALUATION";
    FineTuningExecutionType["PROFILER"] = "PROFILER";
})(FineTuningExecutionType || (FineTuningExecutionType = {}));
export const MODEL_EVALUATION_TASK_LABEL_MAP = {
    custom: "Evaluate with my own data",
    // bbh: "Big-Bench Hard",
    // musr: "Multistep Reasoning",
    // gpqa_diamond_cot: "Graduate-level Q&A Tasks",
    // ifeval: "Tasks with Specific Instruction",
    mmlu: "Massive Multitask Language Understanding",
    gsm8k: "Grade School and Advanced Math Word Problems"
    // mgsm: "Math Word Problems",
    // wikilingua: "Translation Tasks in Multiple Languages"
};
